import gql from "graphql-tag";


export const ROLES = gql`query ($first: Int! $after: String) {
    roles(first: $first after: $after) {
        nodes {
            id
            name
        }
        pageInfo {
            hasNextPage
            endCursor
        }
    }
}`;

export const ROLE = gql`query ($id: ID!) {
    role(id: $id) {
        id
        isSuperAdmin
        name
        permissions
        isDeleted
    }
}`;

export const CREATE_ROLE = gql`mutation ($input: RoleInput!) {
    createRole(
        input: $input
    ) {
        id
        isSuperAdmin
        name
        permissions
        isDeleted
    }
}`;

export const UPDATE_ROLE = gql`mutation ($id: ID! $input: RoleInput!) {
    updateRole(
        id: $id
        input: $input
    ) {
        id
        name
        permissions
    }
}`;

export const DELETE_ROLE = gql`mutation ($id: ID!) {
    deleteRole(
        id: $id
    ) {
        id
        isDeleted
    }
}`;

export const ROLE_PERMISSIONS_CATEGORIES = gql`query {
    rolePermissionsCategories
}`;

export const ROLE_PERMISSIONS_PREREQUISITES = gql`query {
    rolePermissionsPrerequisites
}`;